import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'
import { getFunctions } from 'firebase/functions'

// Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyAqveCOBcVGoHZ93p4MydK2Ib-Lg6HXrbw",
    authDomain: "porcelain-identification-78c76.firebaseapp.com",
    projectId: "porcelain-identification-78c76",
    storageBucket: "porcelain-identification-78c76.firebasestorage.app",
    messagingSenderId: "449403655946",
    appId: "1:449403655946:web:d5fd9c40bf25e895fbccf3"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize services
export const auth = getAuth(app)
export const db = getFirestore(app)
export const storage = getStorage(app)
export const functions = getFunctions(app, 'europe-west1')

export default app
